import React, { Component } from "react";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";


import * as routes from "../../routes";

import { Dimmer, Loader } from 'semantic-ui-react';

import LoginForm from "../../components/Authentication/LoginForm";
import ForgotPasswordForm from "../../components/Authentication/ForgotPasswordForm";

import { changeFormField } from "../../helpers";

import './Authentication.css';

import logo from '../../media/barestho_logo_desk.png';
import { Redirect } from "react-router-dom";

class Login extends Component {

    state = {
        isPasswordForgotten: false,
        loginForm: {
            username: { value: "", modified: false, type: "email", valid: false },
            password: { value: "", modified: false, type: "password", valid: false }
        },
        resetForm: {
            username: { value: "", modified: false, type: "email", valid: false }
        }
    };

    componentDidMount = () => {
        this.props.onGetConnectedUser();
    }

    handleLoginFormChange = (e, { name, value }) => {
        const newForm = changeFormField(this.state.loginForm, name, value);
        this.setState({ loginForm: newForm });
    };

    handleResetPasswordFormChange = (e, { name, value }) => {
        const newForm = changeFormField(this.state.resetForm, name, value);
        this.setState({ resetForm: newForm });
    };

    forgotPasswordHandler = () => this.setState({ isPasswordForgotten: true });

    forgotPasswordSubmit = () => {
        const email = this.state.resetForm.username.value;
        this.props.onResetPasswordEmail(email);
        this.setState({ isPasswordForgotten: false });
    };

    backToLogin = () => this.setState({ isPasswordForgotten: false });

    onLogIn = () => {
        const username = this.state.loginForm.username.value;
        const password = this.state.loginForm.password.value;
        this.props.onLogin(username, password);
    };

    render() {

        const isLoading = this.props.isUserAuthenticated === null || this.props.connectedUserLoading;

        if(isLoading)
            return <Dimmer active>
                <Loader content="Authentification en cours..." />
            </Dimmer>;

        return (
            !this.props.isUserAuthenticated ?
                <div className="barestho-login">
                    <Dimmer active={this.props.getConnectedUserLoading || this.props.loginLoading || this.props.resetPasswordEmailLoading}>
                        <Loader />
                    </Dimmer>
                    <div className="barestho-login-container">
                        <div className="barestho-login-title"><img src={logo} alt="Barestho logo" /></div>
                        <div className="barestho-login-form">
                            {this.state.isPasswordForgotten ?
                                <ForgotPasswordForm
                                    form={this.state.resetForm}
                                    handleChange={this.handleResetPasswordFormChange}
                                    onResetPassword={this.forgotPasswordSubmit}
                                    onReturn={this.backToLogin} /> :
                                <LoginForm
                                    form={this.state.loginForm}
                                    handleChange={this.handleLoginFormChange}
                                    onForgotPassword={this.forgotPasswordHandler}
                                    onLogIn={this.onLogIn} />}
                        </div>
                    </div>
                </div>
                :
                <Redirect to={routes.APP} />
        );
    }
}

const mapStateToProps = state => {
    return {
        isUserAuthenticated: state.authenticationReducer.isUserAuthenticated,
        loginLoading: state.authenticationReducer.loading,
        resetPasswordEmailLoading: state.authenticationReducer.resetPasswordEmailLoading,
        connectedUserLoading: state.authenticationReducer.connectedUserLoading,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogin: (username, password) => dispatch(actionTypes.login(username, password)),
        onResetPasswordEmail: (email) => dispatch(actionTypes.resetPasswordEmail(email)),
        onGetConnectedUser: () => dispatch(actionTypes.getConnectedUser()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/Authentication/Login.js